import type { EmployeeModuleKey } from './types';

/** All modules inserted on accept / listed in Equipo admin. Order is stable UI sort. */
export const EMPLOYEE_PERMISSION_MODULES: readonly EmployeeModuleKey[] = [
  'POS',
  'Catalog',
  'Inventory',
  'Fiado',
  'Reports',
  'BranchSettings',
  'Promotions',
  'PriceLists',
  'Loyalty',
  'Expenses',
  'Purchases',
  'Agenda',
  'WorkOrders',
  'Commissions',
  'Cash',
  'Checks',
  'Orders',
  'Tables',
  'Kitchen',
  'MenuOptions',
  'Team',
  'Organization',
  'Billing',
  'Support',
] as const;

export function isEmployeeModuleKey(value: string): value is EmployeeModuleKey {
  return (EMPLOYEE_PERMISSION_MODULES as readonly string[]).includes(value)
    || value === 'Customers';
}

/**
 * Fase C expand: 'Customers' is the new module key, 'Fiado' is the DB-persisted value.
 * Normalize to 'Fiado' when writing to DB, normalize to 'Customers' when reading for UI.
 */
export function normalizeModuleKeyForDb(module: string): string {
  return module === 'Customers' ? 'Fiado' : module;
}

export function normalizeModuleKeyFromDb(module: string): string {
  return module === 'Fiado' ? 'Customers' : module;
}
